import { type FC } from 'react';
import '@/components/UI/FormElements/Radio/Radio.scss';
import { CollectionMethod } from '@/model/SamplePlan.model.ts';

interface CollectionMethodSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

const CollectionMethodSelector: FC<CollectionMethodSelectorProps> = ({ value, onChange }) => {
  return (
    <div data-test-component="CollectionMethodSelector" data-test-element="container">
      <div className="ui__form__radio mb3" data-test-element="option" data-test-key="quick-collect">
        <input
          id="quick-collect-radio"
          type="radio"
          value={CollectionMethod.quick_collect}
          checked={value === CollectionMethod.quick_collect}
          onChange={(e) => onChange(e.target.value)}
          data-testid="quick-collect-input"
        />
        <div className="ui__form__radio__custom"></div>
        <label htmlFor="quick-collect-radio" className="dib relative pl4 lh-copy mb0">
          <span data-testid="quick-collect-label">Quick collect</span>
          <p className="f6 lh-copy ma0 dark-gray" data-testid="quick-collect-description">
            Collect all samples in bulk using shared details and a single collection time.
          </p>
        </label>
      </div>

      <div className="ui__form__radio mb3" data-test-element="option" data-test-key="sampling-sheet">
        <input
          id="sampling-sheet-radio"
          type="radio"
          value={CollectionMethod.sampling_sheet}
          checked={value === CollectionMethod.sampling_sheet}
          onChange={(e) => onChange(e.target.value)}
          data-testid="sampling-sheet-input"
        />
        <div className="ui__form__radio__custom"></div>
        <label htmlFor="sampling-sheet-radio" className="dib relative pl4 lh-copy mb0">
          <span data-testid="sampling-sheet-label">Collect by sampling sheet</span>
          <p className="f6 lh-copy ma0 dark-gray" data-testid="sampling-sheet-description">
            Record each sample in real time with unique details and collection times.
          </p>
        </label>
      </div>
    </div>
  );
};

export default CollectionMethodSelector;
